import { Injectable, inject, signal } from '@angular/core';

import { AuthSession } from './auth-session.model';
import { PORTAL_MODE } from './portal-mode';

@Injectable({ providedIn: 'root' })
export class SessionStore {
  private readonly portalMode = inject(PORTAL_MODE);
  private readonly storageKey = `junoaudit.${this.portalMode}.auth.session`;
  private readonly sessionState = signal<AuthSession | null>(this.restore());

  readonly session = this.sessionState.asReadonly();

  snapshot(): AuthSession | null {
    return this.sessionState();
  }

  setSession(session: AuthSession): void {
    localStorage.setItem(this.storageKey, JSON.stringify(session));
    this.sessionState.set(session);
  }

  clear(): void {
    localStorage.removeItem(this.storageKey);
    this.sessionState.set(null);
  }

  private restore(): AuthSession | null {
    const rawSession = localStorage.getItem(this.storageKey);
    if (!rawSession) {
      return null;
    }

    try {
      return JSON.parse(rawSession) as AuthSession;
    } catch {
      localStorage.removeItem(this.storageKey);
      return null;
    }
  }
}
